var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",class:{ closeSidebar: !_vm.collapseSidebar },attrs:{"id":"facebook-sidebar"}},[_c('topsidebar'),_c('bottomsidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }